import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Critical UI Crash:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="h-screen w-screen bg-[#0a0a0a] flex flex-col items-center justify-center p-6 text-center">
          <div className="w-16 h-16 border border-hair flex items-center justify-center mb-6">
            <span className="text-2xl text-[var(--sev-critical)]">!</span>
          </div>
          <h1 className="font-display text-2xl text-white mb-2">SYSTEM ERROR</h1>
          <p className="text-[12px] text-white/60 font-mono mb-8 max-w-md">
            The dashboard encountered a fatal rendering exception. This is often caused by external scripts or race conditions.
          </p>
          <div className="flex gap-4">
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-2 bg-white text-black text-[11px] font-display uppercase tracking-widest hover:bg-white/90 transition-colors"
            >
              Reload System
            </button>
            <button
              onClick={() => this.setState({ hasError: false })}
              className="px-6 py-2 border border-white/20 text-white text-[11px] font-display uppercase tracking-widest hover:bg-white/5 transition-colors"
            >
              Retry Session
            </button>
          </div>
          <pre className="mt-12 p-4 bg-black/40 border border-hair text-[9px] text-left text-white/40 overflow-auto max-w-2xl max-h-[200px] w-full">
            {this.state.error?.toString()}
          </pre>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
